import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { App } from './app'
import { createApi } from './lib/api'
import { createSupabaseAuth } from './lib/auth'
import { AppProviders } from './lib/providers'
import { createSupabaseRealtime } from './lib/realtime'
import { rememberReturnTo } from './lib/return-to'
import { routes } from './routes'
import './styles.css'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string
// A API atende em api.westhetics.io (T30); sem VITE_API_URL, no endereço do próprio projeto.
const apiUrl = (import.meta.env.VITE_API_URL as string | undefined) || `${supabaseUrl}/functions/v1`

const auth = createSupabaseAuth(supabaseUrl, anonKey)
// A lista de assinaturas e a ficha reagem na hora ao que a paciente faz (RN-ASS-32).
const realtime = createSupabaseRealtime(supabaseUrl, anonKey, () => auth.getAccessToken())
const api = createApi({
  baseUrl: apiUrl,
  anonKey,
  getAccessToken: () => auth.getAccessToken(),
  // 401: a sessão acabou. Limpa e volta ao login com o motivo (RN-AUT-19). Quem está numa tela
  // sem sessão (login, convite, entrar com código) fica onde está: ali não há sessão para vencer.
  onUnauthenticated: () => {
    // Sessão vencida no meio do consentimento do MCP: depois de entrar, a pessoa volta ao pedido.
    rememberReturnTo(`${window.location.pathname}${window.location.search}`)
    void auth.signOut().then(() => {
      const publicPaths: string[] = [
        routes.login,
        routes.invite,
        routes.signInCode,
        routes.anamnesisForm,
        routes.photoSession,
      ]
      if (!publicPaths.includes(window.location.pathname)) {
        window.location.assign(`${routes.login}?reason=expired`)
      }
    })
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders api={api} auth={auth} realtime={realtime}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppProviders>
  </StrictMode>,
)
